import { render, staticRenderFns } from "./SessionTimeoutWarning.vue?vue&type=template&id=25f97784&scoped=true"
import script from "./SessionTimeoutWarning.vue?vue&type=script&lang=js"
export * from "./SessionTimeoutWarning.vue?vue&type=script&lang=js"
import style0 from "./SessionTimeoutWarning.vue?vue&type=style&index=0&id=25f97784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f97784",
  null
  
)

export default component.exports